module.exports = __webpack_public_path__ + "img/img_about_3.fcef7f97.jpg";